import React, {useContext, useEffect, useLayoutEffect, useState }from 'react';
import { RouteProps, useNavigate } from 'react-router-dom';
import { AuthService } from '../services/AuthService';
import AuthorizeContext from '../components/applayout/AuthrizeContext';


interface ProtectedRouteProps extends Omit<RouteProps, 'element'> {
    element: React.ReactNode;
    pageName: string;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, pageName }) =>{
    const navigate = useNavigate();
    const authService = new AuthService();
    const [isLogedin, setIsLogedin] = useState(false);

    const userPermissions = useContext(AuthorizeContext);
    const [isPermissionAllowed, setIsPermissionAllowed] = useState<boolean>(false);

    useEffect(() => {
        setIsPermissionAllowed(false);
        userPermissions?.permissions.forEach((permission) => {
            switch(pageName){
                case 'Update Ticket':
                    if(permission.permissionName === 'MI' && permission.canWrite){
                        setIsPermissionAllowed(true);
                    }
                    break;
                case 'Correct Ticket':
                    if(permission.permissionName === 'All transactions' && permission.canWrite){
                        setIsPermissionAllowed(true);
                    }
                    break;
                 case 'Reports':
                    if(permission.permissionName === 'MI' && permission.canWrite){
                        setIsPermissionAllowed(true);
                    }
                    break;
                case 'Admin':
                    if(permission.permissionName === 'MI' && permission.canWrite){
                        setIsPermissionAllowed(true);
                    }
                    break;
                default:
                    if(permission.permissionName === pageName && permission.canView){
                        setIsPermissionAllowed(true);
                    }

                    /* * Hot fix for bulk upload.*/
                    /*if(pageName == 'Admin'){
                        setIsPermissionAllowed(true);
                    }
                    break; */
            }
        });
    },[pageName, userPermissions])
    
    useLayoutEffect(() => {
        authService.getUser()
        .then((resultUser) => {
            if(resultUser){
                setIsLogedin(true);
            }else{
                setIsLogedin(false);
                navigate('/');
            }
        });
    }, []);
    

    let content;

    if (isLogedin) {
        if (userPermissions?.isPermissionLoaded) {
            content = isPermissionAllowed ? element : <div>You do not have access</div>;
        } else {
            content = <div>Loading Permission</div>;
        }
    } else {
        content = <div>Loading</div>;
    }


    return (
        <> 
            {content}
        </>
    )
}
export default ProtectedRoute;